import { JAVASCRIPT_QUERY, TYPESCRIPT_QUERY } from './queries';

/** A tree-sitter grammar we can outline. Each maps to one grammar `.wasm`. */
export type SymbolLanguageId = 'typescript' | 'tsx' | 'javascript';

/** File extension (lowercase, no dot) -> grammar. */
const EXT_TO_LANGUAGE: Record<string, SymbolLanguageId> = {
  ts: 'typescript',
  mts: 'typescript',
  cts: 'typescript',
  tsx: 'tsx',
  js: 'javascript',
  jsx: 'javascript',
  mjs: 'javascript',
  cjs: 'javascript',
};

/** Extensions (no dot) for which a code outline is available. */
export const SUPPORTED_OUTLINE_EXTENSIONS: ReadonlySet<string> = new Set(
  Object.keys(EXT_TO_LANGUAGE),
);

/**
 * Grammar id for a file name by extension, or null when no code outline applies
 * (markdown, unsupported languages, extensionless files). Pure; safe in core.
 */
export function outlineLanguageForFile(name: string): SymbolLanguageId | null {
  const dot = name.lastIndexOf('.');
  if (dot < 0 || dot === name.length - 1) return null;
  const ext = name.slice(dot + 1).toLowerCase();
  return EXT_TO_LANGUAGE[ext] ?? null;
}

/**
 * The definitions query for a grammar. `typescript` and `tsx` share the TS query
 * (the tsx grammar is the TS grammar plus JSX); `javascript` uses a subset that
 * omits TS-only node types (interfaces, enums, type aliases, namespaces).
 */
export function queryFor(lang: SymbolLanguageId): string {
  return lang === 'javascript' ? JAVASCRIPT_QUERY : TYPESCRIPT_QUERY;
}
